import React, { useEffect, useState } from "react";
import styles from "./scss/contact-details.module.scss";
import { Tabs, Tooltip } from "antd";
//import MainMenus from "../chat/menus";
import ContactSavedChat from "./contactWidgets/contactSavedChat";
import ContactLinksChat from "./contactWidgets/contactLinks";
import FileListCenter from "./contactWidgets/contactFiles";
import { URAvatarGroup } from "../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../shared/widgets/avatarGroup/statusDot";
import { initialStateModel } from "../../models/model";
import { useSelector } from "react-redux";
import { getcontactDetail } from "../../base/utils";
import { ChatService } from "../../base/chatService";
import { useHistory } from "react-router-dom";
import TaskContactMain from "./rightsidebar/taskContactMain";
import EventContactMain from "./rightsidebar/eventContactMain";
import NotesContactMain from "./rightsidebar/notesContactMain";
import { toastInformation, userStatusColor } from "../../base/callService/common";
import { initiateCall, initiateGroupCall, sendDirectGroupVideoCallRequest, sendDirectVideoCallRequest } from "../../base/callService/callService";
import { SocketChatService } from "../../base/socketChatService";
import { generateChatID, userInfo } from "../../base/socketChatService/utils";
import { chatSideWindow } from "../../base/eventService/eventApiService";
import _ from "lodash";
import { storeHoldTeam } from "../../base/callService/store_mining";
import teamIcn from "../../styles/images/teamimg.svg";
import singleIcon from "../../styles/images/Welaunch_Profile_Pic.svg";
import MessageIcon from "../../styles/svgIcons/messageIcon";
import CallIcon from "../../styles/svgIcons/call";
import MeetIcon from "../../styles/svgIcons/meetIcon";
import ContactUserDetails from "./contactUserDetails";
import store from "../../context/store/store";


const URContactsListsMainFrame = React.memo((props: any) => {

  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  let { contactWindowDetails, isWindowSlide } = allReducer.contactWindowReducer;
  let { userdetails } = allReducer.loginReducer;

  let newCallUpdatedCallList: any = allReducer.updatedCallList
  const [contactScreenCallBtn, setContactScreenCallBtn] = useState(false)
  // const makeAudioCall = () => {
  //   let data = contactWindowDetails;
  //   if(data.ext) { initiateCall(data.ext,'audio'); }
  //   else { toastInformation("Please check the number","failure"); }
  // };

  /* if(isMyspace){
    isMyspace = true;
    contactWindowDetails.caller_id = userdetails.caller_id;
    contactWindowDetails.jid = `${userdetails.sip_login_id}@${userdetails.host_address}`;
    contactWindowDetails.ext = userdetails.ext;
    contactWindowDetails.email_id = userdetails.email_id;
    contactWindowDetails.user_status = userdetails.user_status;
    contactWindowDetails.ImageURL = "";
    contactWindowDetails.isMyspace = true;

    contactWindowDetails.is_favourite = userdetails.email_id;
    contactWindowDetails.is_blocked = userdetails.email_id;
    contactWindowDetails.is_muted = userdetails.email_id;
  } */

  let history = useHistory();
  const OpenChatWindow = () => {
    const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
    if (contactWindowDetails?.sip_login_id) {
      let chatDetail = { chatId: generateChatID(userInfo().fromID, contactWindowDetails.sip_login_id.toString()) };

      socketservice.openChatWindow(contactWindowDetails, history, chatDetail, 'contactpage');
    } else {
      socketservice.openChatWindow(contactWindowDetails, history, '', 'contactpage');
    }
    ChatService.editDraft("");
    ChatService.saveChatHighlight(false, {});
    ChatService.filesHighlight(false, {});
    chatSideWindow(false, "", {});
  };

  const contactFav = (contactDetails: any) => {
    const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
    let chatId: any = contactDetails.sip_login_id ?
      generateChatID(userInfo().fromID, contactDetails?.sip_login_id.toString()) : contactDetails?.team_id.toString();
    let teamMemberFavourite = contactDetails?.team_members_favourite ? contactDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
    let chatDetails = {
      chatId: chatId,
      settingsKey: "isFavourite",
      toSipId: contactDetails?.sip_login_id ? contactDetails?.sip_login_id?.toString() : contactDetails?.team_id?.toString(),
      type: contactDetails?.sip_login_id ? 1 : 2,
      status: (contactDetails?.is_favourite || (Array.isArray(teamMemberFavourite) && teamMemberFavourite.length > 0 &&
        teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1)) ? 0 : 1,
      phoneNumber: contactDetails?.ext ? contactDetails?.ext : ""
    };
    const timer = setTimeout(() => {

      socketservice.toastUndo("", "")
    }, 3000);
    let name = contactDetails?.team_id ? contactDetails?.team_name : contactDetails?.caller_id;
    console.log(contactDetails, "contactDetails")
    if ((!contactDetails?.is_favourite && contactDetails?.sip_login_id) || ((Array.isArray(teamMemberFavourite) &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id) === -1) && contactDetails?.team_id)) {
      socketservice.updateRecentChatSettings(chatDetails);
      socketservice.toastUndo("Added to Favourites", timer, 'favourite');
    } else {
      socketservice.updateRecentChatSettings(chatDetails);
      socketservice.toastUndo("Removed Favourites", timer, 'unfavourite');
    }
  }

  useEffect(() => {
   
    // {Conatact mainScreen Top-Right call feature(For Group)}
    const ConatactMainScreenGrpCall = planBased.find((item:any) => item.featureid === 49);
    if (ConatactMainScreenGrpCall && ConatactMainScreenGrpCall.value1 === "Yes") {
      setContactScreenCallBtn(false); 
    } else {
      setContactScreenCallBtn(true);
    }
    
  }, [planBased]); 
  
  const muteContact = () => {

    const socketservice = new SocketChatService(userdetails.sip_login_id, userdetails.domain_id);
    let muteValue = contactWindowDetails?.sip_login_id ? contactWindowDetails.is_muted === 0 ? 1 : 0
      : currentTeamMember.includes(userdetails.sip_login_id) === true ? 0 : 1;


    let chatDetails = {
      chatId: contactWindowDetails.chatId,
      settingsKey: "isMuted",
      toSipId: contactWindowDetails?.sip_login_id ? contactWindowDetails?.sip_login_id.toString() :
        contactWindowDetails?.team_id.toString(),
      status: muteValue,
      type: contactWindowDetails?.sip_login_id ? 1 : 2,
      phoneNumber: contactWindowDetails?.ext ? contactWindowDetails?.ext : ""
    };
    socketservice.updateRecentChatSettings(chatDetails);

  }
  const { TabPane } = Tabs;
  // const operations = <div className={styles.profilelists}>
  //   <div className={styles.lefts}><span>D<b></b></span></div>
  //   <div className={styles.middle}>
  //     <h4>{contactWindowDetails?.caller_id}</h4>
  //     <p><span className={styles.numberSec}>02034440424 </span>
  //       <span className={styles.ext}>{contactWindowDetails?.ext}</span></p>
  //   </div>
  // </div>;


  let teamMemberNames: any = [];
  let teamMemberarrayforImage: any;
  if (contactWindowDetails?.team_id) {

    teamMemberarrayforImage = contactWindowDetails?.team_id && contactWindowDetails?.team_members &&
      contactWindowDetails?.team_members.replace(" ", "").split(',');

    teamMemberarrayforImage?.map((list: any) => {
      let c_details = getcontactDetail(list);
      teamMemberNames.push(c_details?.caller_id);
    });
  }
  /*   const makeAudioCall = (data: any) => {
      if(data) {
        if(data.ext) { initiateCall(data.ext,'audio'); }
        else { initiateGroupCall('single',data.team_id); }
      }
      else { toastInformation("Please check the number","failure"); }
    }; */

  const startCallInitate = (data: any) => {
    if (_.isEmpty(newCallUpdatedCallList.callDetails)) {
      (data.team_id) ? initiateGroupCall('single', (data.team_id).toString()) : initiateCall(data.ext, "audio");
    }
    else {
      if (newCallUpdatedCallList.callDetails[0].holdState === true) {
        (data.team_id) ? initiateGroupCall('single', (data.team_id).toString()) : initiateCall(data.ext, "audio");
      } else {
        if (data.team_id) {
          storeHoldTeam(true, 'Group', (data.team_id).toString())
        }
        else {
          let det:any=newCallUpdatedCallList.callDetails.findIndex((elem:any)=>{
            return   elem.ext === data.ext
          })
          if(det === -1) 
         { storeHoldTeam(true, 'Normal', data.ext)}
         else{
          toastInformation("You are already in call with this user")
         }
        }
      }
    }

  }

  // const makeGroupCall = (data:any) => {
  //   let arrCall:any = [];
  //   data.ext ? arrCall.push(data.ext) : arrCall.push('con' + data.team_id)
  //     if(_.isEmpty(newCallUpdatedCallList.callDetails) ){
  //       initiateGroupCall('single', data.team_id);
  //     }else{
  //       store.dispatch({
  //         type: Types.TEAM_CALL_HOLD,
  //         payloads: {
  //           isTeamCallHold :true ,
  //           isTeamHoldNum : arrCall
  //         }
  //     });
  //     }
  // }

  // const malkeSingleCall = (data:any) =>{
  //   let arrCall:any = [];
  //   data.ext ? arrCall.push(data.ext) : arrCall.push('con' + data.team_id)
  //   if(_.isEmpty(newCallUpdatedCallList.callDetails) ){
  //     initiateCall(data.ext,"audio");
  //   }else{
  //     store.dispatch({
  //       type: Types.TEAM_CALL_HOLD,
  //       payloads: {
  //         isTeamCallHold :true ,
  //         isTeamHoldNum : arrCall
  //       }
  //   });
  //   }
  // }
  const makevideoCall = (data: any) => {

    if (data?.ext) {
      //initiateCall(data.ext,'video');
      sendDirectVideoCallRequest(data);
    }
    // else { toastInformation("Please check the number", "failure"); }
    sendDirectGroupVideoCallRequest(data.teammembersdetails)
  };

  let teamMemberFavourite = contactWindowDetails?.team_members_favourite ? contactWindowDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
  let teamMemberMuted = contactWindowDetails?.team_members_muted ? contactWindowDetails?.team_members_muted.split(",").map((ele: any) => ele.trim()) : [];
  let currentTeamMember = Array.isArray(teamMemberMuted) && teamMemberMuted.length > 0 ? teamMemberMuted.map((value: any) => value.split('_')[0]) : [];
  let colorIndex = allReducer.recentChatTabReducer?.tabrecentindex > 7 ? (allReducer.recentChatTabReducer?.tabrecentindex - Math.floor((allReducer.recentChatTabReducer?.tabrecentindex / 8)) * 8) + 1
    : allReducer.recentChatTabReducer?.tabrecentindex + 1
  return (
    <>

      <div className={`${styles.topsections} ${styles.bordernon}`}>

        <div className={`${styles.profilelists} ${styles.widthfull}`}>
          {/*   <div className={styles.lefts}><span>{contactWindowDetails?.caller_id?.charAt(0)}<b></b></span></div> */}

          {contactWindowDetails?.is_blocked === 1 ? <URAvatarGroup className={`lefts size38`}
            profileInfo={<> <img src={singleIcon} alt="team icon" />
            </>} /> : contactWindowDetails?.team_id && contactWindowDetails?.profile_image_url ?
            <URAvatarGroup className='lefts size48' profileInfo={
              <>
                {contactWindowDetails?.profile_image_url &&
                  <img src={contactWindowDetails?.profile_image_url} alt="" />}
              </>
            } />
            : contactWindowDetails?.team_id ? <URAvatarGroup className={`lefts size38 colorBG${colorIndex}`}
              profileInfo={<> {contactWindowDetails?.profile_image_url ?
                <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> :
                <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>} </>}
            /> : contactWindowDetails?.caller_id &&
            <URAvatarGroup className={`lefts size38 colorBG${colorIndex}`} profileInfo={
              <>
                {contactWindowDetails?.ImageURL ?
                  <img src={contactWindowDetails?.ImageURL} alt=""></img>
                  : <span>{contactWindowDetails?.first_name?.charAt(0).toUpperCase() + contactWindowDetails?.last_name?.charAt(0).toUpperCase()}</span>
                }
                {!contactWindowDetails?.team_id && <URStatusDot
                  className={userStatusColor(contactWindowDetails?.user_status, 'small')} />}


              </>
            } />
          }


          <div className={`${styles.middle} ${styles.flexdirection}`}>
            <h4>
              <Tooltip mouseEnterDelay={0.5} title={contactWindowDetails?.team_id ? contactWindowDetails?.team_name : contactWindowDetails?.caller_id}
                className='cusTooltip' overlayClassName='customTooltip'><b>{contactWindowDetails?.team_id ? contactWindowDetails?.team_name : contactWindowDetails?.caller_id}</b></Tooltip>


            </h4>
            <h4 className={styles.notificationbtm}>
              <Tooltip mouseEnterDelay={0.5} placement="top" title={contactWindowDetails?.team_id ? Array.isArray(teamMemberFavourite) &&
                teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1
                ? "Remove from Favourites" : "Add to Favourites" : contactWindowDetails?.is_favourite ? "Remove from Favourites" : "Add to Favourites"} className='cusTooltip'
                overlayClassName='customTooltip'>
                {(contactWindowDetails?.team_id || contactWindowDetails?.sip_login_id) &&
                  <span className={`${((Array.isArray(teamMemberFavourite) && teamMemberFavourite.length > 0 &&
                    teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1) || (contactWindowDetails?.is_favourite)) ?
                    "icon_starfill cgreen" : "icon_star "} ${contactWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} onClick={() => contactFav(contactWindowDetails)}></span>}
              </Tooltip>


              {contactWindowDetails?.sip_login_id ?
                <Tooltip mouseEnterDelay={0.5} placement="top" title={contactWindowDetails.is_muted === 0 ? "Mute all Notifications" : contactWindowDetails.is_muted === 1 && "Unmute all Notification"}>
                  <span onClick={muteContact} className={`${contactWindowDetails.is_muted === 1 ? ` icon_fillnotification ` : "icon_notification"} ${contactWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}></span>
                </Tooltip>
                :
                <Tooltip mouseEnterDelay={0.5} placement="top" title={Array.isArray(currentTeamMember)
                  && currentTeamMember.indexOf(userdetails.sip_login_id) > -1 ? "Unmute all Notifications" : "Mute all Notification"}>
                  <span onClick={muteContact} className={currentTeamMember.indexOf(userdetails.sip_login_id) > -1 ? ` icon_fillnotification ` : "icon_notification"}></span>
                </Tooltip>
              }

              {/* <Tooltip placement="top" title={contactWindowDetails.team_id && contactWindowDetails.Mute_Notification === 0
                ? "Mute all Notifications" : contactWindowDetails.team_id && contactWindowDetails.Mute_Notification === 1
                  ? "Unmute all Notification" : contactWindowDetails.is_muted === 0
                    ? "Mute all Notifications" : contactWindowDetails.is_muted === 1 && "Unmute all Notification" }>
                <span onClick={muteContact} className={contactWindowDetails.is_muted === 1 || contactWindowDetails.Mute_Notification === 1
                ?` icon_fillnotification ` :"icon_notification"}></span>
                </Tooltip> */}
            </h4>
          </div>
          {/* <div className={styles.righticon}>
            <div className={styles.actionIconright}>
              <div className={`${styles.callIcon} ${contactWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} onClick={() => startCallInitate(contactWindowDetails)}><span></span> </div>
              <div className={`${styles.chatIcon} ${contactWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} onClick={() => OpenChatWindow()}><span></span> </div>
              <div className={`${styles.meetIcon} ${contactWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} onClick={() => makevideoCall(contactWindowDetails)}><span></span> </div>
            </div>

          </div> */}
        </div>
        <div className={styles.actionIcon}>	
          <div className="messageIcon" onClick={() => OpenChatWindow()}><MessageIcon /></div>	
          <div className={`messageIcon ${(contactScreenCallBtn && contactWindowDetails.hasOwnProperty('team_id') === true) ? 'disabledIcon':''}`} onClick={() => startCallInitate(contactWindowDetails)}><CallIcon /></div>	
          <div className="messageIcon" onClick={() => makevideoCall(contactWindowDetails)}><MeetIcon /></div>	
        </div>
      </div>
      <div className={`scroller ${styles.chatinnerframe} `}>
        <div className={styles.tabHeader}>
          <Tabs /*tabBarExtraContent={operations}*/ className={isWindowSlide ? `myspaceSec contactresizetoggle` : "myspaceSec contactSpace"}>

            {/* <TabPane tab="Chat (me)" key="1">
              <ChatFilesMessage  />
              <Affix offsetTop={36}>
                <Divider plain className="dividerDate">22 Aug at 5:20 AM</Divider>
              </Affix>
              <ChatShareMessage />
            </TabPane> */}
            <TabPane tab="Details" key="1">
              <ContactUserDetails />
            </TabPane>
           {/* <TabPane tab="Tasks" key="2">
               <TaskListsCenter /> 
              <TaskContactMain handleRightWindow={props.handleRightWindow} />
            </TabPane> */}
            {/* <TabPane tab="Events" key="3">
              <EventContactMain handleRightWindow={props.handleRightWindow} />
            </TabPane> */}
            <TabPane tab="Files" key="4">
              <FileListCenter />
            </TabPane>
            <TabPane tab="Saved Chats" key="5">
              <ContactSavedChat handleRightWindow={props.handleRightWindow} />
            </TabPane>
            {/* <TabPane  tab="Notes" key="6">
              <NotesContactMain handleRightWindow={props.handleRightWindow} />
              <NotesListsCenter></NotesListsCenter>
            </TabPane> */}
            <TabPane tab="Links" key="7">
              <ContactLinksChat handleRightWindow={props.handleRightWindow} />
            </TabPane>
          </Tabs>
        </div>
      </div>
      {/* </div>
        </div>

          <div className={isActive ? `${styles.framerightsidebar} 
          ${styles.hideframerightsidebar}` : `${styles.framerightsidebar}`}>
            <TaskViewDetails></TaskViewDetails>
           
          </div>
        </div>
      </div> 
 */}
      {/* <div className={props.isActive ? `${styles.framerightsidebar} 
          ${styles.hideframerightsidebar}` : `${styles.framerightsidebar}`}>
       Hello World
      </div> */}
    </>
  );
});


export default URContactsListsMainFrame;